module.exports = __webpack_public_path__ + "media/images/common/lp/bg-ribbon-left-6fcc7bc5cf2980155ae34728a1e12503.svg";